import { SecondaryButton } from '@egalite/ui/Buttons/GeneralButtons';
import Icon from '@egalite/ui/Icon';
import Typography from '@egalite/ui/Typography';
import { FC, ReactElement } from 'react';

export const TrueIcon: FC = () => <span className='flex items-center justify-center'><Icon className="fi fi-br-check text-accent-main text-3xl" /></span>;
export const FalseIcon: FC = () => <span className='flex items-center justify-center'><Icon className="fi fi-br-cross text-base-grey-4 text-xl" /></span>;

export const BenefitsHeaderCell: FC<{ children: ReactElement | string }> = ({ children }) => (
	<Typography variant="sub-headline-1" color="brand.main" className="text-center p-8 py-12 uppercase" asEl="th">
		{children}
	</Typography>
);
export const BenefitsCell: FC<{ children: ReactElement | string }> = ({ children }) => (
	<Typography variant="body-1" className="text-center first:font-bold first:text-right w-[22%] first:w-[34%] p-8 px-2 first:px-8" asEl="td">
		{children}
	</Typography>
);
export const BenefitsRow: FC<{ children: ReactElement | ReactElement[] }> = ({ children }) => (
	<tr className="text-center first:last:odd:bg-none odd:bg-gradient-to-r from-transparent via-base-grey-3 to-transparent">{...Array.isArray(children) ? children : [children]}</tr>
);

export const BenefitsTable: FC<{ children: ReactElement | ReactElement[] }> = ({ children }) => (
	<div className="hidden lg:block rounded-3xl border border-solid border-base-grey-3 my-28 px-12 w-full">
		<table className="table-auto w-full">{...Array.isArray(children) ? children : [children]}</table>
	</div>
);